import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {
  Container,
  Navbar,
  Offcanvas,
  Nav,
} from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom"; // Import useLocation
import "../Header/header.css";

const Header = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation(); // Track the current route

  const toggleMenu = () => {
    setOpen(!open);
  };

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  }, []);

  // Sticky Header Logic
  const isSticky = () => {
    const header = document.querySelector(".header-section");
    const scrollTop = window.scrollY;
    if (scrollTop >= 120) {
      header.classList.add("is-sticky");
    } else {
      header.classList.remove("is-sticky");
    }
  };

  const closeMenu = () => {
    if (window.innerWidth <= 991) {
      setOpen(false);
    }
  };

  // Function to check if a route is active
  const isActiveRoute = (route) => location.pathname === route;

  return (
    <header className="header-section">
      <Container>
        <Navbar expand="lg" className="p-0">
          {/* Logo Section */}
          <Navbar.Brand>
            <NavLink to="/">
              <img
                src="assets/images/WhatsApp_Image_2025-03-03_at_5.56.39_PM-removebg-preview.png"
                alt="Weekendmonks Logo"
                className="logo-img"
              />
            </NavLink>
          </Navbar.Brand>
          {/* End Logo Section */}

          <Navbar.Offcanvas
            id="offcanvasNavbar-expand-lg"
            aria-labelledby="offcanvasNavbarLabel-expand-lg"
            placement="start"  
            show={open} 
          >
            {/* Mobile Logo Section */}
            <Offcanvas.Header>
              <img
                src="assets/images/WhatsApp_Image_2025-03-03_at_5.56.39_PM-removebg-preview.png"
                alt="Weekendmonks Logo"
                className="logo-img"
              />
              <span className="navbar-toggler ms-auto" onClick={toggleMenu}>
                <i className="bi bi-x-lg"></i>
              </span>
            </Offcanvas.Header>
            {/* End Mobile Logo Section */}

            <Offcanvas.Body>
              <Nav className="justify-content-end flex-grow-1 pe-3">
                {/* Add `active` class dynamically */}
                <NavLink
                  className={`nav-link ${isActiveRoute("/") ? "active" : ""}`}
                  to="/"
                  onClick={closeMenu}
                >
                  HOME
                </NavLink>
                <NavLink
                  className={`nav-link ${isActiveRoute("/about-us") ? "active" : ""}`}
                  to="/about-us"
                  onClick={closeMenu}
                >
                  ABOUT US
                </NavLink>
                <NavLink
                  className={`nav-link ${isActiveRoute("/tours") ? "active" : ""}`}
                  to="/tours"
                  onClick={closeMenu}
                >
                  TOURS
                </NavLink>
                <NavLink
                  className={`nav-link ${isActiveRoute("/gallery") ? "active" : ""}`}
                  to="/gallery"
                  onClick={closeMenu}
                >
                  GALLERY
                </NavLink>
                <NavLink
                  className={`nav-link ${isActiveRoute("/contact-us") ? "active" : ""}`}
                  to="/contact-us"
                  onClick={closeMenu}
                >
                  CONTACT
                </NavLink>
                <NavLink
  className={`nav-link ${isActiveRoute("/contact-us") ? "active" : ""}`}
  to="/contact-us"
  onClick={closeMenu}
>
  CONTACT
</NavLink>

<NavLink
  className={`nav-link ${isActiveRoute("/privacy-policy") ? "active" : ""}`}
  to="/privacy-policy"
  onClick={closeMenu}
>
  PRIVACY POLICY
</NavLink>

<NavLink
  className={`nav-link ${isActiveRoute("/terms-and-conditions") ? "active" : ""}`}
  to="/terms-and-conditions"
  onClick={closeMenu}
>
  TERMS & CONDITIONS
</NavLink>

                {/* Book Now Button inside the mobile menu only */}
                <NavLink to="/contact-us">
                  <Button
                    className="button-3d d-lg-none" // Hide on desktop
                    style={{ backgroundColor: "#FDBB42", border: "none", marginTop:"3px" }}
                  >
                    Book Now
                  </Button>
                </NavLink>


                {/* Social Media Icons inside the mobile menu */}
                <div className="d-flex  mt-3 d-lg-none"> {/* Added d-lg-none */}
                <a href="#" class="bi bi-facebook"></a>
<a href="#" class="bi bi-twitter"></a>
<a href="#" class="bi bi-google"></a>
<a href="#" class="bi bi-linkedin"></a>
<a href="#" class="bi bi-youtube"></a>
                </div>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>

          {/* Desktop Book Now Button */}
          <div className="ms-md-4 ms-2">
            <NavLink to="/contact-us">
              <Button
                className="button-3d d-none d-lg-block" // Show only on desktop
                style={{ backgroundColor: "#FDBB42", border: "none" }}
              >
                Book Now
              </Button>
            </NavLink>

            {/* Mobile Menu Toggle */}
            <li className="d-inline-block d-lg-none ms-3 toggle_btn">
              <i
                className={open ? "bi bi-x-lg" : "bi bi-list-nested"}
                onClick={toggleMenu}
              ></i>
            </li>
          </div>
        </Navbar>
      </Container>
    </header>
  );
};

export default Header;
